import { Link } from 'react-router-dom';
import { site, columns } from '@/mocks/columns';

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-100">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="md:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-primary-500 text-base font-bold text-background-50">
              料
            </span>
            <span className="font-heading text-xl font-bold tracking-wide text-background-50">
              看料社
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/90">
            {site.intro.slice(0, 60)}…
          </p>
          <p className="mt-4 text-xs uppercase tracking-[0.25em] text-accent-300">{site.latin}</p>
        </div>

        <nav aria-label="看料栏目">
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-accent-300">
            看料栏目
          </h4>
          <ul className="space-y-3 text-sm">
            {columns.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/lanmu/${c.slug}`}
                  className="text-background-100/85 transition-colors hover:text-accent-200"
                >
                  {c.name}
                  <span className="ml-2 text-xs text-background-400">{c.en}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="站点导航">
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-accent-300">
            站点导航
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/" className="transition-colors hover:text-accent-200">
                首页
              </Link>
            </li>
            <li>
              <Link to="/lanmu" className="transition-colors hover:text-accent-200">
                全部栏目
              </Link>
            </li>
            <li>
              <Link to="/guanyu" className="transition-colors hover:text-accent-200">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/lianxi" className="transition-colors hover:text-accent-200">
                联系我们
              </Link>
            </li>
          </ul>
        </nav>

        <div>
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-accent-300">
            编辑部来信
          </h4>
          <p className="text-sm leading-relaxed text-background-100/80">
            深扒线索、行业观察与栏目建议，欢迎来信。
          </p>
          <a
            href={`mailto:${site.email}`}
            className="mt-3 inline-flex items-center gap-2 text-sm text-accent-200 hover:text-accent-100"
          >
            <i className="ri-mail-line text-base" aria-hidden="true" />
            {site.email}
          </a>
          <div className="mt-5 flex gap-2 text-background-100/80">
            <span aria-hidden="true" className="flex h-8 w-8 items-center justify-center rounded-md bg-background-800">
              <i className="text-base ri-weibo-line" />
            </span>
            <span aria-hidden="true" className="flex h-8 w-8 items-center justify-center rounded-md bg-background-800">
              <i className="text-base ri-wechat-line" />
            </span>
            <span aria-hidden="true" className="flex h-8 w-8 items-center justify-center rounded-md bg-background-800">
              <i className="text-base ri-douban-line" />
            </span>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© 2026 看料社 · 编辑部出品 · 本站内容仅代表编辑部视角，供参考阅读。</p>
          <p className="flex items-center gap-1">
            <i className="ri-leaf-line text-sm" aria-hidden="true" />
            理性看料，认真求证
          </p>
        </div>
      </div>
    </footer>
  );
}